import { RootState } from '../../store'
import { AssetWebDto } from '../../api/types'
import { AlpsAssetWithMarginCode } from '../../types/Asset'
import { TestingState } from './tests/selectors.test'

const formatAssets = (
  assetsV1: AlpsAssetWithMarginCode[],
  assetsV2: AssetWebDto[]
) => {
  return assetsV2.map(assetV2 => {
    const assetV1 = assetsV1.find(
      asset => asset.sequence === assetV2.assetSequenceNumber
    )
    const symbol =
      assetV2.identifiers.find(identifier => identifier.type === 'SYMBOL')
        ?.value || ''
    const cusip =
      assetV2.identifiers.find(identifier => identifier.type === 'CUSIP')
        ?.value || ''
    const position =
      assetV2.longShort === 'L'
        ? 'LONG'
        : assetV2.longShort === 'S'
        ? 'SHORT'
        : ''
    const quantity = assetV2.quantity === 0 ? '' : assetV2.quantity
    const description = assetV2.description
    const amount = assetV2.amount
    const currency = assetV2.currency.isoCode
    const accountType = assetV1?.cashMarginShortCode || ''
    const settlingLocation = assetV1?.settlingLocation || ''
    const settlingLocationReason =
      assetV1?.settlingLocationReason === 'Undefined ()'
        ? '—'
        : assetV1?.settlingLocationReason || ''

    return {
      id: assetV1?.sequence || 0,
      symbol,
      cusip,
      position,
      quantity,
      description,
      amount,
      currency,
      accountType,
      settlingLocation,
      settlingLocationReason,
    }
  })
}

// V1 and V2 in this context refer to the V1 assets endpoint and the V2 details endpoint
export const deliveringAssetsSelector = (state: RootState | TestingState) => {
  const assetsV1 = state.assetsReducer?.assets
  const assetsV2 =
    state.transferDetailsReducer?.transferDetails?.deliveringAssets
  return assetsV1.length > 0 && assetsV2 ? formatAssets(assetsV1, assetsV2) : []
}

export const receivingAssetsSelector = (state: RootState | TestingState) => {
  const assetsV1 = state.assetsReducer?.assets
  const assetsV2 =
    state.transferDetailsReducer?.transferDetails?.nonDeliverableAssets
  return assetsV1.length > 0 && assetsV2 ? formatAssets(assetsV1, assetsV2) : []
}
